module.exports = __webpack_public_path__ + "static/media/video.a961672b.png";